import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { ArrowUp } from 'lucide-react';

export const StickyCTA = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling down 400px
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToForm = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 animate-in fade-in slide-in-from-bottom-4 duration-300">
      <Button
        size="lg"
        onClick={scrollToForm}
        className="bg-green-600 hover:bg-green-700 text-white shadow-2xl px-6 py-6 text-base font-semibold rounded-full flex items-center gap-2 transition-all hover:scale-105"
      >
        <ArrowUp className="w-5 h-5" />
        <span className="hidden sm:inline">Get Free Analysis</span>
        <span className="sm:hidden">Get Quote</span>
      </Button>
    </div>
  );
};
